module.exports = __webpack_public_path__ + "img/Avatar@2x.7ab6def4.png";